import React from 'react';
import NavButton from '../../homepage/header-banner/TopNavButton';
import TrafficFee from '../../homepage/header-banner/TrafficFee';
import MySql from '../../homepage/header-banner/MySql';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import CardBox from '../../container/Box/Components/CardBox'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import ClickHouse from '../../homepage/header-banner/ClickHouse';
import '../../Style/typo.css'
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';
import { useEffect } from 'react';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


function ClusterclickhouseVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Private ClickHouse Cluster - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for ClickHouse")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}

                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Hệ quản trị cơ sở dữ liệu mã nguồn mở dạng cột, được thiết kế cho xử lý phân tích trực tuyến thời gian thực (OLAP).</p>",
                                `<p class="typo-14">Dữ liệu được ghi vào các nút khả dụng, sau đó được sao chép và phân phối đến tất cả các nút trong hệ thống.</p>
                                <p class="typo-14">Có khả năng lưu trữ và xử lý dữ liệu ở quy mô petabyte.</p>
                                <p class="typo-14">Mang lại hiệu suất nhanh hơn hơn 100 lần so với các hệ quản trị cơ sở dữ liệu truyền thống, lý tưởng cho các tác vụ phân tích dữ liệu thời gian thực.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Dữ liệu được phân phối và lưu trữ trong các Shard, hỗ trợ mô hình đa chủ bất đồng bộ.</p>",
                                `<p class="typo-14">Hệ thống cho phép sao chép đa chủ bất đồng bộ và thu thập dữ liệu từ các nút sao chép.</p>
                                <p class="typo-14">Dữ liệu được phân phối trong các Shard, thực hiện tính toán song song và sau đó hợp nhất kết quả.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Vận hành Persistent Volume với hiệu suất cao, tối ưu hóa khả năng I/O.</p>",
                                `<p class="typo-14">Hệ thống sử dụng volume PV SSD, với 3 container replica (POD) tạo thành một đơn vị dịch vụ.</p>
                                <p class="typo-14">Ngay cả khi phần cứng của một worker node trong Kubernetes gặp sự cố, dịch vụ vẫn tiếp tục hoạt động trên các container (POD) của các worker node khác.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động di chuyển container (POD) khi gặp sự cố phần cứng, đảm bảo hoạt động liên tục và không gián đoạn.</p>",
                                `<p class="typo-14">Các container (POD) của Kubernetes ClickHouse bao gồm 3 node replica cho mỗi dịch vụ đơn vị.</p> 
                                <p class="typo-14">Các replica container (POD) được phân bổ trên nhiều worker node trong Kubernetes, giúp tăng cường tính sẵn sàng và khả năng chịu lỗi của hệ thống.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động mở rộng quy mô (autoscaling), cho phép mở rộng container và phân phối tải dịch vụ hiệu quả.</p>",
                                `<p class="typo-14">Số lượng container (POD) được điều chỉnh định kỳ dựa trên các chỉ số như CPU, bộ nhớ hoặc các metrics tùy chỉnh khác.</p>
                                <p class="typo-14">Dịch vụ có thể vận hành mà không cần bổ sung tài nguyên phần cứng để mở rộng.</p>
                                <p class="typo-14">Đây là giải pháp cluster hiệu quả, giúp phân phối tải và tối ưu hóa chi phí dịch vụ.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>{Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-clickhouse/clickhouse.jpeg")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <ClickHouse />
                        <TrafficFee /> */}
                        {/* <CloudconsultCp /> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>
            {/* <Cloudconsult /> */}
            {/* <Footer /> */}
            <FooterVn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClusterclickhouseVN;
